<!--<div class="home">
  <app-home></app-home>-->
<!-- <app-cms></app-cms> -->
<!--</div>-->
<!--<body>
  <router-outlet></router-outlet>
  <div class="logout-warn hiddenidle">
    <h3 class="heading-warn">You are Idle for a while.You will be logout in {{math.round(mcountdown/60)}} minutes</h3>
    <div class="btnsss">
      <button class="logout" (click)="LogoutClick()">Logout</button>
      <button class="stay" (click)="StayClick()">Stay</button>
    </div>
  </div>
</body>-->
<body class="new-class-for-body ">
  <router-outlet></router-outlet>
  <div class="main_Warn " id="main_Warn">
    <div class="main-sub-warn">

    </div>
    <div class="logout-warn ">
      <div>

        <img src="assets\img\dribbble-hourglass-unscreen.gif" class="image-dritle" />
        <h3 class="heading-warn">You are Idle for a while.You will be logout in <span class="counter-minutes-idle">{{math.round(mcountdown/60)}} minutes </span></h3>
        <div class="btnsss">
          <button class="logout" (click)="LogoutClick()">Logout</button>
          <button class="stay" (click)="StayClick()">Stay</button>
        </div>
      </div>
    </div>
  </div>
</body>
